import { Flex, Image, Text, useColorMode, useColorModeValue } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebase-config";
// import { moment } from "moment";

import { Link } from 'react-router-dom'
import { getUserInfo } from '../utils/fetchData';
import moment from 'moment/moment';

const avatar = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTuhV7d2KM5ElJEfSRNnCJLwSqFw_D4yzutw&usqp=CAU'

const VideoPin = ({ data }) => {
  const firestoreDb = getFirestore(firebaseApp);

  const [userId, setUserId] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const { colorMode } = useColorMode();
  const bg = useColorModeValue('blackAlpha.700', 'gray.900');
  const textcolor = useColorModeValue('gray.100', 'gray.100');



  useEffect(() => {
    if (data) setUserId(data.userId)
    if (userId) getUserInfo(firestoreDb, userId).then((data) => {
      setUserInfo(data)
    })
  }, [userId])

  return (
    <Flex
      justifyContent={'space-between'}
      alignItems='center'
      direction={'column'}
      shadow={'lg'}
      cursor='pointer'
      _hover={{ shadow: "xl" }}
      rounded='md'
      overflow={"hidden"}
      position="relative"
      maxWidth={"260px"}
      maxHeight={'200px'}
    >
      <Link to={`/videoDetail/${data.id}`} >
        <video
          src={data.videoUrl}
          muted
          onMouseOver={(e) => e.target.play()}
          onMouseOut={(e) => e.target.pause()}
        />
      </Link>

      <Flex
        position={'absolute'}
        bottom='0'
        left='0'
        p={2}
        bg={bg}
        width='full'
        direction={'column'}
      >
        <Flex
          width={'full'}
          justifyContent='space-between'
          alignItems={'center'}
        >
          <Text color={textcolor} isTruncated fontSize={20}> {data.title}</Text>

          <Link to={`/userDetail/${userId}`}>
            <Image
              src={userInfo?.photoURL ? userInfo?.photoURL : avatar}
              rounded='full'
              width={'50px'}
              height={'50px'}
              border='2px'
              borderColor={bg}
              mt={-10}
              minHeight={'50px'}
              minWidth={'50px'}
            />
          </Link>
        </Flex>
        <Text
          fontSize={12}
          color={textcolor}
          ml='auto'
        >
          {
            moment(new Date(parseInt(data.id)).toISOString()).fromNow()
          }
        </Text>
      </Flex>
    </Flex>
  )
}

export default VideoPin